var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("TwemojiPicker", {
    attrs: {
      emojiData: _vm.emojiDataAll,
      emojiGroups: _vm.emojiGroups,
      skinsSelection: false,
      searchEmojisFeat: false,
      pickerArrowEnabled: false,
      pickerAutoflip: false,
      searchEmojiPlaceholder: "Search here.",
      searchEmojiNotFound: "Emojis not found.",
      isLoadingLabel: "Loading...",
      "picker-placement": "bottom-start",
      "picker-width": 290,
      "picker-height": 180
    },
    on: { emojiUnicodeAdded: _vm.select },
    scopedSlots: _vm._u([
      {
        key: "twemoji-picker-button",
        fn: function() {
          return [_c("div", { staticClass: "comment-emoji__image" })]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }